import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import CheckIcon from '@material-ui/icons/Check';

import DateRangeIcon from '@material-ui/icons/DateRange';
import EditLocationIcon from '@material-ui/icons/EditLocationRounded';
import ShiftIcon from '@material-ui/icons/SyncAlt';
import KidsIcon from '@material-ui/icons/PeopleAltRounded';
import DayvisitIcon from '@material-ui/icons/CakeRounded';
import EraseIcon from '@material-ui/icons/DeleteRounded';
import ArrowIcon from "@material-ui/icons/ArrowForwardIosRounded";
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";

import { EditPaneStyle } from './EditPane.style';
import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import SleepAtParent from './editActions/SleepAtParent/SleepAtParent';
import ChangeTimePlace from './editActions/ChangeTimePlace/ChangeTimePlace';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import Dayvisit from './editActions/Dayvisit/Dayvisit';
import ShiftDays from './editActions/ShiftDays/ShiftDays';
import Wizard from './editActions/Wizard/Wizard';
import Children from './editActions/Children/Children';
import { createArrayCopyAndSort } from './editActions/ScheduleCalc';
import ScheduleAiEdit from './editActions/AiEdit/ScheduleAiEdit';
import Cleardays from './editActions/Cleardays/Cleardays';
import { EditPaneOption } from './EditPane.types';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  step:1|2;
  showMoreOptions:boolean;
}

interface IProps extends WithStyles<typeof EditPaneStyle> {
  family:IFamilyMember[];
  inEditMode:boolean;

  selectedDays:IDateRange[];
  suggestionId:number;
  option:EditPaneOption;
  setEditOption:(option:EditPaneOption) => void;
  // monthViewReference:React.RefObject<HTMLDivElement>;
  open:boolean;
  localization: 'se'|'en';
  scheduleEditBase:ISchedule|undefined; 
  scheduleEditPreview:ISchedule|undefined; 
  updatePreview:(schedule:ISchedule) => void;
  updateBase:(schedule:ISchedule) => void;
  clearSelectedDays:() => void;
  selectRange:(from:number,to:number, days:boolean[]) => void;
  onAiSchedulePrompted:() => void;
  onAiScheduleApplied:(schedule:ISchedule) => void;
  // setResizing:(isResizing:boolean) => void;
}

class EditPane extends React.Component<IProps, IState> {

  private paneRef:React.RefObject<HTMLDivElement>;
  // private monthViewRef:React.RefObject<HTMLDivElement>;
  private paneStart: number = 0;
  private paneHeight:number = 0;
  private isMouseDragging:boolean = false;

  constructor(props: IProps) {
    super(props);
    // this.monthViewRef = props.monthViewReference;
    this.paneRef = React.createRef();


    this.state = {
      step:1,
      showMoreOptions:false,
    };

  }
  public componentDidMount(): void {
    this.setHeight(this.props.open?400:0);
  }

  public componentWillUnmount(): void {
    this.detachMouseHandlers();
  }
  
  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (this.props.open !== prevProps.open) {
      this.setHeight(this.props.open?400:0);
      if (this.props.open) {
        this.props.setEditOption("select");
        this.setState({step:1})
      }
    }
    if (this.props.option !== prevProps.option) {
      if (this.props.option === "dayvisit" || this.props.option === "timePlace" 
        || this.props.option === "shift" || this.props.option === "cleardays") {
        this.setHeight(250);
      }
    }

  } 

  public render() {


    const {classes, selectedDays, scheduleEditBase, scheduleEditPreview, family, option} = this.props;
    const {step} = this.state;

    let actionPage:JSX.Element = <div />;

    if (scheduleEditBase !== undefined) {
      switch (option) {
        case 'shift': 
          actionPage = <ShiftDays   
            close={(finished) => this.back(false,finished)}
            selectedDays={selectedDays}
            scheduleEditBase={scheduleEditBase} 
            scheduleEditPreview={scheduleEditPreview} 
            updatePreview={this.props.updatePreview}
            updateBase={this.props.updateBase}/>
          break;
        case 'children':
          actionPage = <Children   
            close={(finished) => this.back(false,finished)}
            scheduleEditBase={scheduleEditBase} 
            updateBase={this.props.updateBase}/>
          break;
        case 'dayvisit':
          actionPage = <Dayvisit   
            close={(finished) => this.back(false, finished)}
            selectedDays={selectedDays}
            scheduleEditBase={scheduleEditBase} 
            scheduleEditPreview={scheduleEditPreview} 
            updatePreview={this.props.updatePreview}
            updateBase={this.props.updateBase}/>
          break;
        case 'cleardays':
          actionPage = <Cleardays   
            close={(finished) => this.back(false, finished)}
            scheduleEditBase={scheduleEditBase} 
            scheduleEditPreview={scheduleEditPreview} 
            updatePreview={this.props.updatePreview}
            updateBase={this.props.updateBase}/>
          break;
        case 'timePlace':
          actionPage = <ChangeTimePlace   
            close={(finished) => this.back(false,finished)}
            selectedDays={selectedDays}
            scheduleEditBase={scheduleEditBase} 
            updatePreview={this.props.updatePreview}
            updateBase={this.props.updateBase}/>
          break;
        case 'wizard':
          actionPage = <Wizard   
            localization={this.props.localization}
            selectRange={this.props.selectRange}
            family={this.props.family}
            close={(finished) => this.back(false,finished)}
            selectedDays={selectedDays}
            scheduleEditBase={scheduleEditBase}
            scheduleEditPreview={scheduleEditPreview}
            updatePreview={this.props.updatePreview}
            updateBase={this.props.updateBase}/>
          break;
        case 'aiedit':
          actionPage = (
            <div className={classes.paneChange} style={{overflow: 'hidden', position: 'relative'}}>
              <ScheduleAiEdit close={(finished) => {this.back(false,finished)}} scheduleEditBase={scheduleEditBase}
                scheduleEditPreview={scheduleEditPreview} setHeight={(pixels) => this.setHeight(pixels)}
                updateBase={this.props.updateBase} updatePreview={this.props.updatePreview}
                onPromptSent={this.props.onAiSchedulePrompted}
                onScheduleApplied={this.props.onAiScheduleApplied} />
            </div>
          );
          break;
      }
    }

    if (scheduleEditBase !== undefined) {

      const pA = family.find((mem) => mem.id === scheduleEditBase.data.parentA);
      const pB = family.find((mem) => mem.id === scheduleEditBase.data.parentB);

      if (pA === undefined || pB === undefined) {return (<div/>);}

      let numberOfMarkedDays:number = 0;
      
      for(const range of this.props.selectedDays) {
        const days = Math.round((range.end - range.start)/(1000*60*60*24));
        numberOfMarkedDays+=days;
      }

      return (
        <div className={classes.pane} ref={this.paneRef}
          style={{display:(this.props.inEditMode?'flex':'none'), height:0, maxHeight:0}}>
          <div className={classes.paneDragger} onClick={() => {return;}} style={{cursor:'ns-resize'}}
            onTouchStart={(e) => this.moveStart(e)} 
            onTouchMove={(e) => this.moveMove(e)} 
            onTouchEnd={(e) => this.moveEnd(e)}
            onMouseDown={this.handleMouseDown} ><div className={classes.paneMarker}/>
          </div>
          <div style={{position:'relative', flex: 1, overflow: 'hidden'}}>
            <div className={classes.paneReplacable}>
              {this.paneActions(scheduleEditBase)}
            </div>
            <div className={classes.paneReplacable} style={{ transform: 'translate('+(step===1?100:0)+'%, 0px)', transition: 'transform 0.3s'}}>
              {actionPage}
            </div>
          </div>
        </div>);
    } else {
      return (
        <div className={classes.pane} ref={this.paneRef}
          style={{display:(this.props.inEditMode?'flex':'none'), height:0, maxHeight:0}}>
          <div className={classes.paneDragger} onClick={() => {return;}} style={{cursor:'ns-resize'}}
            onTouchStart={(e) => this.moveStart(e)} 
            onTouchMove={(e) => this.moveMove(e)} 
            onTouchEnd={(e) => this.moveEnd(e)}
            onMouseDown={this.handleMouseDown} ><div className={classes.paneMarker}/>
          </div>
          <div style={{position:'relative', flex: 1, overflow: 'hidden'}}>
            <div className={classes.paneReplacable}>
              <div className={classes.paneOptions} >
                <Button className={classes.paneOption} style={{textAlign: 'start'}} onClick={() => this.back(true, false)}>{tn.lang.back}</Button>
                <div className={classes.paneOption} style={{minHeight:'20px'}} />
                <div className={classes.paneOption} style={{minHeight:'20px'}} />
              </div>
            </div>
            <div style={{overflow:'auto'}}>
              No valid schedule is selected.
            </div>
          </div>
        </div>);
    }
  }

  private setHeight(height:number) {

    if (this.paneRef.current) {
      this.paneRef.current.style.height = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.maxHeight = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.minHeight = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.border = ((this.props.open
        ?`1px solid ${styleColors.greyMedium1}`
        :`0px solid ${styleColors.greyMedium1}`
      ));
      this.paneRef.current.style.boxShadow = ((this.props.open
        ?'0px 0px 10px rgba(113, 101, 113, 0.27)'
        :'0px 0px 10px rgba(113, 101, 113, 0)'));
      this.paneHeight = (this.props.open?height:0);
    }
  }

  private paneActions(base:ISchedule):JSX.Element {
    const {classes, family, option} = this.props;
    const kidsId = this.props.scheduleEditPreview?this.props.scheduleEditPreview.data.children:base.data.children;
    const kidsName = tn.familyMemberNames(kidsId,family);

    return (<>
      <div className={classes.paneOptions} >
        <Button className={classes.paneOption} classes={{text:classes.paneBackButton}} style={{textAlign: 'start'}} 
          onClick={() => this.back(true, false)} startIcon={<BackArrowIcon />}>{tn.lang.back}</Button>
        <div style={{width: 'calc(200%/3)', textAlign: 'end', opacity:(this.state.step===1?0:1), pointerEvents:(this.state.step===1?'none':'auto')}}>
          <Button className={classes.paneOption} classes={{text:classes.paneNextButton}} onClick={() => this.setState({step:2})}
              endIcon={<ArrowIcon />}>{tn.lang.calNext}
          </Button>
        </div>
      </div>
      <div style={{overflow:'auto'}}>
        <div className={classes.paneActions}>
          <div style={option==="wizard"?{backgroundColor: styleColors.greyMedium1}:{}} onClick={() => this.selectOption("wizard", true, true)}>
            <div className={classes.paneAction}>
              <DateRangeIcon  className={classes.paneActionIcon}/>
              <div className={classes.paneActionTitle}>
                {tn.lang.calWizard} 
              </div>
              <div><CheckIcon style={{opacity:option==="wizard"?1:0}} className={classes.checkIcon}/></div>
            </div>
          </div>
          <div style={option==="aiedit"?{backgroundColor: styleColors.greyMedium1}:{}} onClick={() => this.selectOption("aiedit", true, true)}>
            <div className={classes.paneAction}>
              <div style={{minWidth: '24px',marginRight: '12px',minHeight: '24px',display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                Ai
              </div>
              <div className={classes.paneActionTitle}>
                {tn.lang.calAi} 
              </div>
              <div><CheckIcon style={{opacity:option==="aiedit"?1:0}} className={classes.checkIcon}/></div>
            </div>
          </div>
          <div style={option==="timePlace"?{backgroundColor: styleColors.greyMedium1}:{}} onClick={() => this.selectOption("timePlace", true, true)}>
            <div className={classes.paneAction}>
              <EditLocationIcon className={classes.paneActionIcon}/>
              <div className={classes.paneActionTitle}>{tn.lang.calChangeTimePlace}</div>
              <div><CheckIcon style={{opacity:option==="timePlace"?1:0}} className={classes.checkIcon}/></div>
            </div>
          </div>

          <div style={option==="shift"?{backgroundColor: styleColors.greyMedium1}:{}} onClick={() => this.selectOption("shift", true, true)}>
            <div className={classes.paneAction}>
              <ShiftIcon className={classes.paneActionIcon}/>
              <div className={classes.paneActionTitle}>{tn.lang.calShiftDays}</div>
              <div><CheckIcon style={{opacity:option==="shift"?1:0}} className={classes.checkIcon}/></div>
            </div>
          </div>
          <div style={option==="dayvisit"?{backgroundColor: styleColors.greyMedium1}:{}} onClick={() => this.selectOption("dayvisit", true, true)}>
            <div className={classes.paneAction}>
              <DayvisitIcon className={classes.paneActionIcon}/>
              <div className={classes.paneActionTitle}>{tn.lang.calAddVisit}</div>
              <div><CheckIcon style={{opacity:option==="dayvisit"?1:0}} className={classes.checkIcon}/></div>
            </div>
          </div>
          <div style={option==="cleardays"?{backgroundColor: styleColors.greyMedium1}:{}} onClick={() => this.selectOption("cleardays", true, true)}>
            <div className={classes.paneAction}>
              <EraseIcon className={classes.paneActionIcon}/>
              <div className={classes.paneActionTitle}>{tn.lang.calClearDays}</div>
              <div><CheckIcon style={{opacity:option==="cleardays"?1:0}} className={classes.checkIcon}/></div>
            </div>
          </div>
          <div style={option==="children"?{backgroundColor: styleColors.greyMedium1}:{}} onClick={() => this.selectOption("children", true, true)}>
            <div className={classes.paneAction} style={{borderBottom:'none'}}>
                <KidsIcon className={classes.paneActionIcon} />
                <div className={classes.paneActionTitle}>{tn.lang.calChildren}</div>
                <div className={classes.kidsOption}>{kidsName+" >"}</div>
            </div>
          </div>
        </div>
      </div></>
    );
  }

  private selectOption(option:EditPaneOption,
    reset:boolean, directClick:boolean) {

    if (reset && this.props.scheduleEditBase !== undefined) {
      this.props.updatePreview(this.props.scheduleEditBase);
    }

    if (option === "quickedit") {
      this.props.setEditOption(option);
      this.setState({step:1});
      if (directClick) {
        this.props.clearSelectedDays();
      }
      
    } else if (option === "select") {
      this.props.setEditOption("select");
      this.setState({step:1});
    } else if (option === undefined) {
      this.props.setEditOption("select");
      this.setState({step:1});
    } else {
      this.props.setEditOption(option);
      if (option=== "dayvisit" || option === "shift" || option === "wizard" || option === "children" 
        || option === "timePlace"|| option === "aiedit"|| option === "cleardays") {
        setTimeout(() => this.setState({step: 2}), 300);
      }
    }

  }

  private back(closeAll:boolean, finished:boolean) {
    if (this.state.step === 1 || finished) {
      if (this.props.option !== "quickedit") {
        this.selectOption("quickedit", closeAll, false);
      }      
    } else {
      if (this.props.option !== "select") {
        this.selectOption("select", closeAll, false);
        this.props.clearSelectedDays();
        this.setHeight(400);
      }      
    }

  }



  private moveStart(e:React.TouchEvent<HTMLDivElement>) {
    // this.props.setResizing(true);
    this.startPaneDrag(e.touches[0].screenY);
  }

  private moveMove(e:React.TouchEvent<HTMLDivElement>) {
    this.updatePaneDrag(e.touches[0].screenY);
  }

  private moveEnd(e:React.TouchEvent<HTMLDivElement>) {
    // this.props.setResizing(false);
    this.finishPaneDrag();
  }

  private handleMouseDown = (e:React.MouseEvent<HTMLDivElement>) => {
    if (e.button !== 0) {
      return;
    }
    this.isMouseDragging = true;
    this.startPaneDrag(e.screenY);
    window.addEventListener('mousemove', this.handleWindowMouseMove);
    window.addEventListener('mouseup', this.handleWindowMouseUp);
    window.addEventListener('blur', this.handleWindowMouseCancel);
  };

  private handleWindowMouseMove = (e:MouseEvent) => {
    if (!this.isMouseDragging) {
      return;
    }
    this.updatePaneDrag(e.screenY);
  };

  private handleWindowMouseUp = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.finishPaneDrag();
    this.detachMouseHandlers();
  };

  private handleWindowMouseCancel = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.finishPaneDrag();
    this.detachMouseHandlers();
  };

  private startPaneDrag(screenY:number) {
    this.paneStart = screenY;
    if (this.paneRef.current) {
      this.paneRef.current.style.transition = "unset";
    }
  }

  private updatePaneDrag(screenY:number) {
    const newY = screenY;
    const delta =  this.paneStart - newY;

    if (this.paneRef.current) {
      let newPaneHeight:number = this.paneHeight + delta;
      if (newPaneHeight < 200) {newPaneHeight =  200;}
      if (window.innerHeight - newPaneHeight < (50+65)) {newPaneHeight = window.innerHeight-(50+65);}
  

      if (this.paneHeight !== newPaneHeight) {
        this.paneHeight = newPaneHeight;
        this.paneStart = newY;
        this.setHeight(newPaneHeight);
      }
    }
  }

  private finishPaneDrag() {
    this.paneStart=0;
    if (this.paneRef.current) {
      this.paneRef.current.style.transition = "all 0.5s";
    }
  }

  private detachMouseHandlers() {
    window.removeEventListener('mousemove', this.handleWindowMouseMove);
    window.removeEventListener('mouseup', this.handleWindowMouseUp);
    window.removeEventListener('blur', this.handleWindowMouseCancel);
  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family:state.family.family,
  };
}

export default connect(mapStateToProps)(withStyles(EditPaneStyle)(EditPane));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/EditPane.tsx